import React, { useState, useEffect, useContext } from "react";

import db from "../../../services/query";
import lbl from "../../../data/Labels.json";

import { HalfYearContext } from "../../../contexts/halfYearContext";
import { PopUpContext } from "../../../contexts/popUpContext";

import DataTable from "./SubAccountsExpensesList";
import MainButton from "../../common/MainButton";
import MainTitle from "../../common/MainTitle";
import TableMainSearch from "../../common/MainSearch";
import MainPrintLink from "../../common/MainPrint";
import { isFinanceReadOnly } from "../../../utils/financeAccess";
import useParityAccess, { useAccessReady } from "../../common/useParityAccess";

const EXPENSE_SCOPE_KEYS = [
  "view-expenses",
  "create-expenses",
  "edit-expenses",
  "delete-expenses",
  "view-expenses-teacher-salary",
  "view-expenses-staff-salary",
  "view-expenses-direct",
  "view-expenses-indirect",
  "view-expenses-debt",
  "view-expense-budgets",
  "print-expense-receipt",
];

const SubAccountsExpenses = (props) => {
  const [data, setData] = useState([]);
  const [query, setQuery] = useState("");

  const { halfYear } = useContext(HalfYearContext);
  const { togglePopUp, popUp } = useContext(PopUpContext);

  const { tid, aid, sid } = props.match.params;
  const can = useParityAccess();
  const ready = useAccessReady();
  const expenseScoped = ready && EXPENSE_SCOPE_KEYS.some((key) => can(key));
  const canCreateExpense = !isFinanceReadOnly() && (!expenseScoped || can("create-expenses"));

  useEffect(() => {
    const ac = new AbortController();

    requestData({ halfYear });

    return () => ac.abort();
  }, [halfYear, popUp]);

  const requestData = async (params = new Object()) => {
    try {
      const { halfYear } = params;

      let query = `expenses/types/${tid}/accounts/${aid}/subAccounts/${sid}/expenses?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainButton title={lbl.PrevPage} type={"back"} />
          <MainTitle title={data?.summary?.title} />
        </div>
        <div className="center-content">
          <TableMainSearch setQuery={setQuery} />
        </div>
        <div className="left-content">
          {canCreateExpense && (
          <MainButton
            title={lbl.AddExpense}
            handleClick={() => togglePopUp({ form: "expense-form", sid })}
            type={"add"}
          />
          )}
          <MainPrintLink path={`expenses/type/${tid}/account/${aid}/subAccount/${sid}/halfYear/${halfYear}`} />
        </div>
      </div>
      <div className="main-content-body">
        <DataTable data={data} {...props} query={query}
                   params={{type: tid, account: aid, subAccount: sid, halfYear: halfYear }}
        />
      </div>
    </div>
  );
};

export default SubAccountsExpenses;
